module.exports = __webpack_public_path__ + "img/HZ3604-193.3e4221cf.jpg";